module.exports = __webpack_public_path__ + "media/images/svg/processing-loader-296813b7e6d8992c75b93c683c9e5449.svg";